<template>
  <!-- name: '返回栏组件' -->
  <div class="goBackBox">
    <span class="iconClass" @click="handleClick()"></span>
    <span class="titleClass">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "贝蓝捐衣",
    },
    nextPath: {
      type: String,
      default: "",
    },
    curSelectTab: {
      type: String,
      default: "",
    },
    nextQuery: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    handleClick() {
      if (this.nextPath) {
        this.$router.push({
          path: this.nextPath,
          query: this.nextQuery
            ? JSON.parse(this.nextQuery)
            : { curSelectTab: this.curSelectTab },
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goBackBox {
  width: 100%;
  height: 96px;
  line-height: 96px;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  .iconClass {
    position: absolute;
    top: 34px;
    left: 34px;
    &::before,
    &::after {
      position: absolute;
      content: "";
      border-top: 17px transparent dashed;
      border-left: 17px transparent dashed;
      border-bottom: 17px transparent dashed;
      border-right: 17px #fff solid;
    }
    &::before {
      border-right: 17px #333 solid;
    }
    &:after {
      left: 5px;
      border-right: 17px #fff solid;
    }
  }

  .titleClass {
    display: inline-block;
    width: 100%;
    height: 100%;
    font-size: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 46px;
    text-align: center;
  }
}
</style>
